
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  import { controls } from "../../controls";
  
  
  const leinmarking = {
    label: "Le1n Marking",
    pageLabel: "Le1n Marking",
    starting: true,
    url: "leinmarking",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    form:[
//         ...controls.displayText({ width:"col-sm-2",label:"Account Number"}),
//         ...controls.AccountNumber({width:"col-sm-2"}),
//         ...controls.showData({data: "account_number_display",width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2",label:"Saction Amount"}),
//         ...controls.numberOnly({width:"col-sm-2",name: "saction_amount",placeHolder:"Saction Amount"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2",label:"Balance"}),
//         ...controls.numberOnly({width:"col-sm-2",name: "balance",placeHolder:"Balance"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.magicDateLabel({ label: "Open Date", width: "col-sm-2" }),
//         ...controls.magicDate({dateType:"ontype", name: "open_date",width:"col-sm-2"}),
// ,
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.magicDateLabel({ label: "Expire Date", width: "col-sm-2" }),
//         ...controls.magicDate({dateType:"ontype", name: "expiry_date",width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.magicDateLabel({ label: "Mark Date", width: "col-sm-2" }),
//         ...controls.magicDate({dateType:"ontype", name: "mark_date",width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2",label:"Mark Amount"}),
//         ...controls.numberOnly({width:"col-sm-2",name: "mark_amount",placeHolder:"Mark Amount"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2",label:"Mark By"}),
//         ...controls.text({width:"col-sm-2",name: "mark_by",placeHolder:"Mark By"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.displayText({ width:"col-sm-2",label:"Release By"}),
//         ...controls.text({width:"col-sm-2",name: "release_by",placeHolder:"Release By"}),
//         ...controls.displayText({ width:"col-sm-2"}),
//         ...controls.magicDateLabel({ label: "Release Date", width: "col-sm-2" }),
//         ...controls.magicDate({dateType:"ontype", name: "release_date",width:"col-sm-2"}),
      
        
//         ...controls.button({
//           label: "ADD", onclick: {
//             action: "appendToHTMLTable",
//             tableNameField: 'leinmarking_table',
//             requiredField: ["account_number", "account_number_display","saction_amount", "balance", "open_date", "expiry_date", "mark_date","mark_amount","mark_by","release_by","release_date"]
//           }, width: "col-sm-2"
//         }),

        {
            inputType: "table",
            tableTitle: "",
            deletable: true,
            // editable: true,
            // addRows: true,
            tableHeaders: [
              { label: "Sr", type: "autoinc" },
              { label: "Account Number", field: "account_number"  },
              { label: "Name", field: "account_number_display" },
              { label: "Saction Amount", field: "sanction_amount" , displaytype: 'currency' },
              { label: "Balance", field: "balance" , displaytype: 'currency' },
              { label: "Open Date", field: "open_date" ,displaytype:'date'},
              { label: "Exp Date", field: "expiry_date",displaytype:'date' },
              { label: "Mark Date", field: "mark_date",displaytype:'date' },
              { label: "Mark Amount", field: "mark_amount", displaytype: 'currency'  },
              { label: "Mark By", field: "mark_by_display" },
              { label: "Release By", field: "release_by" },
              { label: "Release Date", field: "release_date",displaytype:'date' }
            ],
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            name: "leinmarking_table"
       },
    ]
  }

  export default leinmarking;